import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { ArrowRight, Star, Clock, MapPin, FireSimple, ForkKnife } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { WHATSAPP } from "@/components/public/PublicNav";

const REVIEWS = [
  { name: "Carla Méndez", text: "Los mejores tacos al pastor de Ecatepec. La carne se deshace en la boca, justo como dicen.", stars: 5 },
  { name: "Jorge Ramírez", text: "Atención muy familiar y todo recién hecho. El volcán de pastor es OBLIGATORIO.", stars: 5 },
  { name: "Ana Luisa", text: "Pedí por WhatsApp y llegó caliente. Las salsas son una locura.", stars: 4 },
  { name: "Diego Hernández", text: "Vienes por unos tacos y te quedas a cenar. Ambiente bien chido.", stars: 5 },
  { name: "Sofía R.", text: "Los alambres mixtos rinden muchísimo. Buen precio y rico.", stars: 5 },
  { name: "Luis P.", text: "Tradición pura. Mi familia viene desde hace años.", stars: 5 },
];

export default function Home() {
  const [topProducts, setTopProducts] = useState([]);
  useEffect(() => {
    api.get("/products/public").then((r) => {
      setTopProducts(r.data.filter((p) => p.top_seller).slice(0, 3));
    }).catch(() => { /* silent */ });
  }, []);

  return (
    <div>
      {/* HERO */}
      <section className="relative h-[92vh] min-h-[640px] overflow-hidden">
        <img
          src="https://images.pexels.com/photos/28992999/pexels-photo-28992999.jpeg"
          alt="Trompo de pastor"
          className="absolute inset-0 w-full h-full object-cover scale-[1.08]"
        />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative max-w-7xl mx-auto px-6 h-full flex flex-col justify-end pb-20 md:pb-28">
          <div className="max-w-3xl text-white">
            <div className="fade-up inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/15 text-xs uppercase tracking-[0.25em] mb-6" data-testid="hero-badge">
              <span className="w-2 h-2 rounded-full bg-emerald-400 pulse-dot" /> Abierto · Hasta las 12 a.m.
            </div>
            <h1 className="fade-up-2 font-display text-5xl md:text-7xl font-black tracking-tight leading-[0.95] mb-6">
              La tradición que <span className="text-orange-400">se deshace</span> en tu boca.
            </h1>
            <p className="fade-up-3 text-lg md:text-xl text-white/85 max-w-2xl leading-relaxed mb-10">
              Sabor, calidad y la mejor atención en San Cristóbal Ecatepec. Carne de primera, recetas caseras y el ambiente familiar que ya conoces.
            </p>
            <div className="fade-up-4 flex flex-wrap gap-3">
              <Link to="/menu" data-testid="hero-cta-menu" className="btn-brand h-14 px-7 inline-flex items-center gap-2 text-base">
                Ver Menú <ArrowRight size={20} weight="bold" />
              </Link>
              <Link to="/ubicacion" data-testid="hero-cta-map" className="h-14 px-7 inline-flex items-center gap-2 rounded-xl bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/20 text-white font-semibold text-base">
                Cómo Llegar <MapPin size={20} weight="bold" />
              </Link>
              <a href={WHATSAPP} target="_blank" rel="noreferrer" data-testid="hero-cta-whatsapp" className="h-14 px-7 inline-flex items-center gap-2 rounded-xl bg-emerald-500 hover:bg-emerald-600 text-white font-semibold text-base transition-colors">
                Pedir por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* QUICK STATS BENTO */}
      <section className="max-w-7xl mx-auto px-6 -mt-16 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {[
            { icon: <Star size={28} weight="fill" />, k: "4.4", l: "estrellas en reseñas" },
            { icon: <Clock size={28} weight="fill" />, k: "12 PM", l: "abierto hasta media noche" },
            { icon: <FireSimple size={28} weight="fill" />, k: "8+ años", l: "tradición en Ecatepec" },
            { icon: <ForkKnife size={28} weight="fill" />, k: "+30", l: "platillos en carta" },
          ].map((s, i) => (
            <div key={i} className="bg-white rounded-2xl p-5 md:p-6 border border-zinc-200 shadow-sm">
              <div className="text-brand mb-2">{s.icon}</div>
              <div className="font-display text-2xl md:text-3xl font-black">{s.k}</div>
              <div className="text-xs md:text-sm text-zinc-500 leading-tight mt-1">{s.l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* SIGNATURE DISHES */}
      <section className="max-w-7xl mx-auto px-6 py-24 md:py-32">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-brand font-semibold mb-3">Los favoritos de la casa</div>
            <h2 className="font-display text-4xl md:text-6xl font-black tracking-tight leading-[1.02]">
              Lo que prepara<br />a fuego lento.
            </h2>
          </div>
          <Link to="/menu" data-testid="section-cta-menu" className="self-start md:self-end inline-flex items-center gap-2 text-brand font-semibold hover:gap-3 transition-all">
            Ver carta completa <ArrowRight size={18} weight="bold" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {(topProducts.length ? topProducts : [
            { id: 1, name: "Taco al Pastor", price: 22, image_url: "https://images.pexels.com/photos/8448068/pexels-photo-8448068.jpeg" },
            { id: 2, name: "Volcán de Pastor", price: 45, image_url: "https://images.pexels.com/photos/5201109/pexels-photo-5201109.jpeg" },
            { id: 3, name: "Alambre Mixto", price: 135, image_url: "https://images.unsplash.com/photo-1719948515819-71265e1abb0d" },
          ]).map((p, i) => (
            <article key={p.id} className={`group relative overflow-hidden rounded-3xl bg-zinc-100 ${i === 0 ? "md:row-span-2 aspect-[3/4] md:aspect-auto" : "aspect-[4/5]"}`}>
              <img src={p.image_url} alt={p.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-7 text-white">
                <div className="text-xs uppercase tracking-[0.25em] text-orange-300 mb-2">Top vendido</div>
                <div className="font-display text-3xl md:text-4xl font-black mb-2">{p.name}</div>
                <div className="text-2xl font-semibold">${p.price}</div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* REVIEWS MARQUEE */}
      <section className="bg-zinc-950 text-white py-24 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 mb-12">
          <div className="text-xs uppercase tracking-[0.25em] text-orange-400 mb-3">Lo que dicen los clientes</div>
          <h2 className="font-display text-4xl md:text-6xl font-black">★ 4.4 / 5</h2>
          <p className="text-zinc-400 mt-3 max-w-xl">Más de cientos de reseñas verificadas en Google.</p>
        </div>
        <div className="relative">
          <div className="marquee gap-4 px-6">
            {[...REVIEWS, ...REVIEWS].map((r, i) => (
              <div key={i} className="min-w-[320px] md:min-w-[420px] bg-zinc-900 rounded-2xl p-7 border border-zinc-800">
                <div className="flex gap-1 text-orange-400 mb-3">
                  {Array.from({ length: r.stars }).map((_, j) => <Star key={j} size={16} weight="fill" />)}
                </div>
                <p className="text-zinc-200 leading-relaxed">"{r.text}"</p>
                <div className="text-zinc-500 text-sm mt-4">— {r.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-7xl mx-auto px-6 py-24">
        <div className="relative overflow-hidden rounded-3xl bg-brand text-white p-10 md:p-16">
          <div className="absolute -right-20 -bottom-20 w-72 h-72 rounded-full bg-orange-500/30 blur-3xl" />
          <div className="absolute -left-10 -top-10 w-64 h-64 rounded-full bg-red-900/40 blur-3xl" />
          <div className="relative grid md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="text-xs uppercase tracking-[0.25em] text-orange-200 mb-3">Listos para servirte</div>
              <h2 className="font-display text-4xl md:text-6xl font-black tracking-tight">¿Antojo? Pídelos hoy mismo.</h2>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 md:justify-end">
              <a href={WHATSAPP} target="_blank" rel="noreferrer" data-testid="cta-bottom-whatsapp" className="h-14 px-7 inline-flex items-center justify-center gap-2 rounded-xl bg-white text-brand font-bold hover:bg-orange-100">Pedir por WhatsApp</a>
              <Link to="/menu" data-testid="cta-bottom-menu" className="h-14 px-7 inline-flex items-center justify-center gap-2 rounded-xl bg-black/20 hover:bg-black/30 backdrop-blur-md border border-white/20 text-white font-semibold">Ver Menú</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
